import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc CagFilter defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CagFilterService } from 'services/cagFilter';
 *
 * // create service instance and send/cancel request
 * const cagFilterService = new CagFilterService();
 * const result = await cagFilterService.fetchData( '<user-id>' ); // fetch data
 * cagFilterService.cancel(); // cancel an active request
 */
export class CagFilterService extends HttpService {

    // fetch CAG filter overlay data
    async fetchFiltersData( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data,
            } );

            // handle failure
            if( SERVICE_RESPONSE_STATUS.FAILURE === get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ) ) {
                return {
                    status: SERVICE_RESPONSE_STATUS.FAILURE,
                    data: {
                        description: get( response, 'body.component.data.description', '' ),
                    },
                };
            }

            // handle success
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    carriers: get( response, 'body.component.data.state.carriers', [] ),
                    steps: get( response, 'body.component.structure.steps', {} ),
                    actions: get( response, 'body.component.structure.actions', [] ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
